import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appUpperCase]'
})
export class UpperCaseDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event) {
    this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
    event.srcElement.value = event.srcElement.value.toUpperCase();
  }

}
